export default __webpack_public_path__ + "static/media/Cattura2.3d609090.jpg";